import {useEffect,useState} from 'react';
import {api} from '../api';
import {Link} from '../ui/ScopedLink';
import {useCapability,useStaffSession} from '../ui/StaffSession';
import {withBuildingScope} from '../ui/building-scope';

type Source='document'|'mail'|'event'|'contact'|'register';
type Stream={source:Source;open:number;mine:number;unassigned:number};
const about:Record<Source,string>={mail:'mail conversations',document:'documents',contact:'contacts and senders',event:'calendar invites',register:'building register gaps'};
const order:Source[]=['mail','document','contact','event','register'];

/**
 * The way in to engine questions from the screens people already use (Documents, My Tasks): how many questions are open in each
 * stream, each linking straight to that stream's list with everyone's questions shown. Shows nothing when none are open.
 */
export function QuestionsWaiting({sources=order,reason,compact=false}:{sources?:Source[];reason?:string;compact?:boolean}){
 const session=useStaffSession(),canManage=useCapability('documents:manage');
 const building=session?.effectiveScope.kind==='building'?session.effectiveScope.id:undefined;
 const [streams,setStreams]=useState<Stream[]>([]);
 useEffect(()=>{if(!canManage)return;const controller=new AbortController();
  void api<{streams:Stream[]}>(withBuildingScope('/api/engine-decisions/summary',building),{signal:controller.signal})
   .then(value=>setStreams(value.streams)).catch(()=>setStreams([]));
  return()=>controller.abort();
 },[building,canManage]);
 const shown=order.filter(source=>sources.includes(source)).map(source=>streams.find(s=>s.source===source)).filter((s):s is Stream=>Boolean(s&&s.open>0));
 const total=shown.reduce((n,s)=>n+s.open,0);
 if(!total)return null;
 return <section className={compact?'questions-waiting compact':'panel notice-info questions-waiting'} aria-label="Questions waiting for an answer">
  <h2>{total} {total===1?'question':'questions'} waiting for an answer</h2>
  {reason&&<p>{reason}</p>}
  <ul>{shown.map(s=><li key={s.source}><Link to={`/work/questions?source=${s.source}&assigned=all`}>{s.open} about {about[s.source]}</Link>{s.mine?` · ${s.mine} assigned to you`:''}</li>)}</ul>
 </section>;
}
